/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chartperiodmonth2Inputs */

const en_chartperiodmonth2 = /** @type {(inputs: Chartperiodmonth2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month`)
};

const de_chartperiodmonth2 = /** @type {(inputs: Chartperiodmonth2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat`)
};

/**
* | output |
* | --- |
* | "Month" |
*
* @param {Chartperiodmonth2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const chartperiodmonth2 = /** @type {((inputs?: Chartperiodmonth2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chartperiodmonth2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chartperiodmonth2(inputs)
	return de_chartperiodmonth2(inputs)
});
export { chartperiodmonth2 as "chartPeriodMonth" }